import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder for Up Next, the way the phone's rows drag. On drop, the
// row's new display index PATCHes to the move endpoint; the server maps
// display order back to play order under the current lens. The DOM is
// already in the right order when the request fires, so nothing reloads
// and the page never moves.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-drag-handle]",
      onEnd: (event) => this.moved(event)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async moved(event) {
    if (event.oldIndex === event.newIndex) return
    const url = event.item.dataset.moveUrl
    if (!url) return
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(url, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ to_index: event.newIndex })
    })
    // A failed write means the DOM order is a lie; reload to the truth.
    if (!response.ok) window.Turbo?.visit(window.location.href, { action: "replace" })
  }
}
